// USE MINIFIED FILE
var isDrilldown = false;
var origMenu = null;
var slideTimer = null;
var isBlazernet = window.location.pathname === '/blazernet/';

jQuery(document).ready(function($) {
    if (isBlazernet) {
        rearrangeBlazerNetNotifs();
    } else {
        jQuery(document).foundation();
        transformMenu();
    }

    jQuery(window).resize(function() {
        if (isBlazernet) {
            rearrangeBlazerNetNotifs();
        } else {
            transformMenu();
        }
    });

    // add arrows to sidebar headers
    jQuery('.sidebar-menu-header').each(function(index, el) {
        if (jQuery(this).next().hasClass('sidebar-menu-arrow')) {
        } else {
            jQuery(this).after('<div class="sidebar-menu-arrow"></div>');
        }
    });

    toggleQuickLinksDropDown();
    toggleYourPathDropDown();

    var $contentElements = $('.wpb_content_element');
    $contentElements.attr('tabindex', '0');
});

function toggleQuickLinksDropDown() {
    var quickLinksToggle = jQuery('#header-quick-links');
    quickLinksToggle.click(function(event) {
        quickLinksToggle.toggleClass('active');
    });

    var quickLinks = jQuery('.quick-links > li > a');

    quickLinks.first().keydown(function(event) {
        if (event.which === 9 && event.shiftKey) {
            quickLinksToggle.toggleClass('active');
        }
    });

    quickLinks.last().keydown(function(event) {
        if (event.which === 9 && !event.shiftKey) {
            quickLinksToggle.toggleClass('active');
        }
    });
}

function removeNewsFlash() {
    var object = document.getElementById('news-flash');
    object.parentNode.removeChild(object);
}

function toggleMenu() {
    jQuery('#header-menu-container').toggleClass('open');
    jQuery('body').toggleClass('menu-open');
}

function transformMenu() {
    var windowWidth = window.innerWidth / parseFloat(getComputedStyle(document.querySelector('body'))['font-size']);
    if (windowWidth < 64 && !isDrilldown) {
        isDrilldown = true;
        var menu = jQuery('#header-menu-container > .menu-container > .menu');
        origMenu = menu.clone();
        var options = {parentLink: true};
        new Foundation.Drilldown(menu, options);
        menu.parent().css('max-width', 300);
        menu.removeClass('dropdown');
        menu.removeAttr('data-dropdown-menu');
        menu.find('.is-dropdown-submenu-parent').removeClass('is-dropdown-submenu-parent');
        menu.find('.is-dropdown-submenu').removeClass('is-dropdown-submenu');
    }
    if (windowWidth >= 64 && isDrilldown) {
        isDrilldown = false;
        origMenu.css('display', '');
        jQuery('.is-drilldown').replaceWith(origMenu);
        new Foundation.DropdownMenu(origMenu);
    }
}

function toggleActive($ele) {
    jQuery('.'+$ele).toggleClass('active');
}

function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    } else {
        expires = '';
    }

    document.cookie = name + '=' + value + expires + '; path=/';
}

function getCookie(c_name) {
    if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + '=');

        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf(';', c_start);

            if (c_end == -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return '';
}

// A simple CSS reorder won't work bc it's part of the sidebar, so remove and readd to the DOM
function rearrangeBlazerNetNotifs() {
    var notifs = jQuery('#blazernet-notifications');
    var width = jQuery(window).width();
    if (width < 1024 && !notifs.hasClass('on-top')) {
        notifs.addClass('on-top');
        notifs.remove();
        jQuery('#blazernet-main-grid').prepend(notifs);
    } else if (width >= 1024 && notifs.hasClass('on-top')) {
        notifs.removeClass('on-top');
        notifs.remove();
        jQuery('#sidebar').prepend(notifs);
    }
}

// WordPress auto-appends a novalidate tag to HTML forms for whatever reason that can't be overriden with a filter
function removeNoValidateFormAttribute(formID) {
    jQuery(window).on('load', function () {
        var form = jQuery('#' + formID);
        form.removeAttr('noValidate');
    });
}

function toggleHorizontalContentMenu() {
    var header = jQuery('#horizontal-content-menu-header');
    header.toggleClass('expanded');

    var menuItems = jQuery('#menu-horizontal-content-menu-nav').children();
    menuItems.toggleClass('active');
}

function toggleYourPathDropDown() {
    var yourPathToggle = jQuery('#choose-your-path-select');
    var yourPathDropdown = jQuery('#choose-your-path-links');
    var yourPathText = jQuery('#choose-your-path-select .dropdown-text')[0];
    yourPathToggle.click(function(event) {
        yourPathDropdown.toggleClass('active');
    });

    var yourPathLinks = jQuery('.choose-your-path > li > a');

    Array.from(yourPathLinks).forEach((yourPathLink) => {
        jQuery(yourPathLink).click(function(event) {
            yourPathText.innerHTML = yourPathLink.innerHTML;
            yourPathDropdown.toggleClass('active');
        });
    });

    yourPathLinks.first().keydown(function(event) {
        if (event.which === 9 && event.shiftKey) {
            yourPathDropdown.toggleClass('active');
        }
    });

    yourPathLinks.last().keydown(function(event) {
        if (event.which === 9 && !event.shiftKey) {
            yourPathDropdown.toggleClass('active');
        }
    });
}